"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pascalCamelToKebabCase = void 0;
function pascalCamelToKebabCase(pascalOrCamelStr) {
    pascalOrCamelStr = pascalOrCamelStr[0].toLowerCase() + pascalOrCamelStr.substr(1);
    return pascalOrCamelStr.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
}
exports.pascalCamelToKebabCase = pascalCamelToKebabCase;
